<!-- <ng-container > -->
@for (insurer of policyPDFDisclosureNotice; track insurer; let i = $index) {
  <div class="pdf-page__component">
    <div class="table-pdf-wrap">
      <table class="table table--pdf">
        <thead>
          <tr>
            <th class="cell-condition-title">
              <div class="d-flex align-items-center">
                <span>{{insurer?.header}}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="cell-pdf-sub font-uppercase">
              {{ insurer?.insurer_name }}
            </th>
          </tr>
          <tr>
            <td class="cell-nopad">
              <div class="pdf__data-table">
                <ul class="data data--table data--flipped">
                  @if (insurer?.physical) {
                    <li class="data__row">
                      <label class="data__label">Physical Address</label>
                      <div class="data__cell">{{insurer?.physical}}</div>
                    </li>
                  }
                  @if (insurer?.postal) {
                    <li class="data__row">
                      <label class="data__label">Postal Address</label>
                      <div class="data__cell">{{insurer?.postal}}</div>
                    </li>
                  }
                  @if (insurer?.tel) {
                    <li class="data__row">
                      <label class="data__label">Telephone Number</label>
                      <div class="data__cell">{{insurer?.tel}}</div>
                    </li>
                  }
                  @if (insurer?.fax) {
                    <li class="data__row">
                      <label class="data__label">Fax Number</label>
                      <div class="data__cell">{{insurer?.fax}}</div>
                    </li>
                  }
                  @if (insurer?.email) {
                    <li class="data__row">
                      <label class="data__label">Email Address</label>
                      <div class="data__cell">{{insurer?.email}}</div>
                    </li>
                  }
                  @if (insurer?.website) {
                    <li class="data__row">
                      <label class="data__label">Website</label>
                      <div class="data__cell">{{insurer?.website}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_name) {
                    <li class="data__row">
                      <label class="data__label">Compliance Officer</label>
                      <div class="data__cell">{{insurer?.compliance_name}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_tel) {
                    <li class="data__row">
                      <label class="data__label">Compliance Tel</label>
                      <div class="data__cell">{{insurer?.compliance_tel}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_email) {
                    <li class="data__row">
                      <label class="data__label">Compliance Email</label>
                      <div class="data__cell">{{insurer?.compliance_email}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_postal) {
                    <li class="data__row">
                      <label class="data__label">Compliance Postal</label>
                      <div class="data__cell">{{insurer?.compliance_postal}}</div>
                    </li>
                  }
                  @if (insurer?.license_no) {
                    <li class="data__row">
                      <label class="data__label">License Number</label>
                      <div class="data__cell">{{insurer?.license_no}}</div>
                    </li>
                  }
                  @if (insurer?.reg_no) {
                    <li class="data__row">
                      <label class="data__label">Registration Number</label>
                      <div class="data__cell">{{insurer?.reg_no}}</div>
                    </li>
                  }
                  @if (insurer?.vat_no) {
                    <li class="data__row">
                      <label class="data__label">VAT Number</label>
                      <div class="data__cell">{{insurer?.vat_no}}</div>
                    </li>
                  }
                </ul>
              </div>
            </td>
          </tr>
          @if (insurer?.insurance) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Your {{insurer?.insurer_type_name}} has the following insurance in place to protect you:
              </th>
            </tr>
            <tr>
              <td class="cell-nopad">
                <div class="pdf__data-table">
                  <ul class="data data--table">
                    @for (insuranceValue of insurer?.insuranceParsed; track insuranceValue) {
                      <li class="data__row">
                        <label class="data__label">{{insuranceValue?.insurer_disclosure}}</label>
                        <div class="data__cell">{{insuranceValue.dr[0]?.disclosure_value}}</div>
                      </li>
                    }
                  </ul>
                </div>
              </td>
            </tr>
          }
          @if (insurer?.claims) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Should you have a claim against your policy, please note the following:
              </th>
            </tr>
            <tr>
              <td class="cell-legal">
                @for (claimValue of insurer?.claimsParsed; track claimValue) {
                  <p [innerHtml]="claimValue?.disclosure_value"></p>
                }
              </td>
            </tr>
          }
          @if (insurer?.complaints) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Complaints:
              </th>
            </tr>
            <tr>
              <td class="cell-nopad">
                <div class="pdf__data-table">
                  <ul class="data data--table">
                    @for (complaintsValue of insurer?.complaintsParsed; track complaintsValue) {
                      <li class="data__row">
                        <label class="data__label">{{complaintsValue?.disclosure}}</label>
                        <div class="data__cell">{{complaintsValue?.disclosure_value}}</div>
                      </li>
                    }
                  </ul>
                </div>
              </td>
            </tr>
          }
          @if (insurer?.com_binder_conflict) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Disclosure:
              </th>
            </tr>
            <tr>
              <td class="cell-legal" [innerHtml]="insurer?.com_binder_conflict">
              </td>
            </tr>
          }
          @if (insurer?.binder_disclosure) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Binder Disclosure:
              </th>
            </tr>
            <tr>
              <td class="cell-legal" [innerHtml]="insurer?.binder_disclosure">
              </td>
            </tr>
          }
          @if (insurer?.uma_disclosure) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Underwriter Disclosure:
              </th>
            </tr>
            <tr>
              <td class="cell-legal" [innerHtml]="insurer?.uma_disclosure">
              </td>
            </tr>
          }
          @if (insurer?.conflict_disclosure) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Other key conflicts of interest disclosures:
              </th>
            </tr>
            <tr>
              <td class="cell-nopad">
                <div class="pdf__data-table">
                  <ul class="data data--table data--answers">
                    @for (conflictDisclosure of insurer?.conflictDisclosureParsed; track conflictDisclosure) {
                      <li class="data__row">
                        <label class="data__label">{{conflictDisclosure?.insurer_disclosure}}</label>
                        <div class="data__cell">{{conflictDisclosure.dr[0]?.disclosure_value}}</div>
                      </li>
                    }
                  </ul>
                </div>
              </td>
            </tr>
          }
          @if (insurer?.conflict_email) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Interest management policy can be obtained from:
              </th>
            </tr>
            <tr>
              <td class="cell-nopad">
                <div class="pdf__data-table">
                  <ul class="data data--table">
                    <li class="data__row">
                      <label class="data__label">
                        Email Address
                      </label>
                      <div class="data__cell">
                        {{insurer?.conflict_email}}
                      </div>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          }
          @if (insurer?.premfee_disclosure) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Disclosure of premiums and fees
              </th>
            </tr>
            <tr>
              <td class="cell-legal">
                <p>{{insurer?.premfee_disclosure}}</p>
              </td>
            </tr>
          }
          @if (insurer?.additional_disclosure) {
            <tr>
              <th class="cell-pdf-sub font-uppercase">
                Additional Disclosure:
              </th>
            </tr>
            <tr>
              <td class="cell-legal" [innerHtml]="insurer?.additional_disclosure">
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
<!-- </ng-container> -->
